// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.50015 7.91424L6.91436 2.50003L5.50015 1.08582L0.0859375 6.50003L1.50015 7.91424Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.9144 6.50003L18.5002 1.08582L17.0859 2.50003L22.5002 7.91424L23.9144 6.50003Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0002 3.00003C6.4773 3.00003 2.00015 7.47718 2.00015 13C2.00015 18.5229 6.4773 23 12.0002 23C17.523 23 22.0002 18.5229 22.0002 13C22.0002 7.47718 17.523 3.00003 12.0002 3.00003ZM15 17.4142L11 13.4142V7.5H13V12.5858L16.4142 16L15 17.4142Z"}}]};

const AlarmFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'alarm-filled',
    ref,
    icon: element,
  },
));

AlarmFilledIcon.displayName = 'AlarmFilledIcon';

export default AlarmFilledIcon;
